<script>
import Layout from '../../../layouts/auth'
import appConfig from '@/app.config'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { RESET_PASSWORD } from '@/services/api/auth'
import { MixPanel } from '@/mixin/mixpanel'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default {
  page: {
    title: 'Lupa Kata Sandi',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  mixins: [Helper],
  data() {
    return {
      password: '',
      repassword: '',
      showPassword: false,
      showRepassword: false,
      submitted: false,
      passwordError: false,
      differentPass: false,
      likeOldPass: false,
      email: localStorage.getItem('emailOTP'),
      otp: localStorage.getItem('otpCode'),
      companyName: '',
      username: '',
      accessRight: '',
      userId: null,
      mode: this.$store.state.config.mode,
      showTooltipPassword: false,
      showTooltipRepassword: false,
      passValidationsCases: [
        'lowerCase',
        'specialCharacter',
        'upperCase',
        'minimumLength',
        'number',
      ],
    }
  },
  validations: {
    password: {
      required,
      maxLength: maxLength(50),
      lowerCase: (val) => {
        const lowercaseRegex = /[a-z]/
        return lowercaseRegex.test(val)
      },
      upperCase: (val) => {
        const uppercaseRegex = /[A-Z]/
        return uppercaseRegex.test(val)
      },
      number: (val) => {
        const numberRegex = /\d/
        return numberRegex.test(val)
      },
      specialCharacter: (val) => {
        const specialCharRegex = /[!@#$%^&*(),.?":{}|<>~`[\]\-_+=;'/\\]/
        return specialCharRegex.test(val)
      },
      minimumLength: (val) => {
        return val.length >= 8
      },
      likeOldPass: (val) => {
        return val !== store.state.resetPassword.oldPassword
      },
    },
    repassword: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(50),
    },
  },
  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
    }),
    notification() {
      return this.$store ? this.$store.state.notification : null
    },
    isPasswordMatched() {
      return this.password === this.repassword && !this.$v.repassword.$invalid
    },
    isPasswordValid() {
      return this.isPasswordMatched && !this.$v.$invalid
    },
    passwordValidationsCases() {
      return this.likeOldPass ? [...this.passValidationsCases, 'likeOldPass']
        : this.passValidationsCases
    },
  },
  mounted() {
    this.adjustImageSize()
    this.$v.$touch()
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword
    },
    toggleRepassword() {
      this.showRepassword = !this.showRepassword
    },
    handleSubmit() {
      if (!this.isPasswordValid) return

      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) return
      const input = {
        email: this.email,
        otp: this.otp,
        password: this.password,
        passwordConfirm: this.repassword,
      }
      this.$apollo
        .mutate({
          mutation: RESET_PASSWORD,
          variables: {
            input: input,
          },
        })
        .then((response) => {
          if (
            response.data.resetPasswordOtp.resetPasswordOtp.message ==
            'Password reset failed, confirm password invalid'
          ) {
            this.passwordError = true
            this.differentPass = true
          } else if (
            response.data.resetPasswordOtp.resetPasswordOtp.message ==
            'Password reset failed, new password cannot be the same as the old password'
          ) {
            this.passwordError = true
            this.likeOldPass = true
            this.$store.commit('resetPassword/SET_OLDPASS', input.password)
          } else if (
            response.data.resetPasswordOtp.resetPasswordOtp.message == 'Password reset successful'
          ) {
            this.$router.push({ name: 'Password Changed' })
            this.companyName = response.data.resetPasswordOtp.resetPasswordOtp.users.companyName
            this.username = response.data.resetPasswordOtp.resetPasswordOtp.users.fullname
            this.accessRight = response.data.resetPasswordOtp.resetPasswordOtp.users.accessRight
            this.userId = response.data.resetPasswordOtp.resetPasswordOtp.users.userId
            this.domainName = response.data.resetPasswordOtp.resetPasswordOtp.users.domainName
            localStorage.setItem('domainName', this.domainName)
            MixPanel.methods.actionResetPassword(
              this.mode,
              this.companyName,
              this.username,
              this.email,
              this.accessRight,
              this.userId
            )
          }
        })
    },
    adjustImageSize() {
      this.resizeImage(this.$refs.imgPrimaryLogo, 45, 150)
      this.resizeImage(this.$refs.imgCopyrightLogo, 15, 50)
    },
    onShowTooltip(obj) {
      if (obj.key === 'Repassword') this.showTooltipRepassword = true
      else if (obj.key === 'Password') this.showTooltipPassword = true
    },
    onHideTooltip(obj) {
      if (obj.key === 'Repassword') this.showTooltipRepassword = false
      else if (obj.key === 'Password') this.showTooltipPassword = false
    },
  },
}
</script>
<style scoped lang="scss">
@mixin custom-tooltip-styles {
  position: absolute;
  padding: 10px;
  background: $white;
  z-index: 1;
  border: 1px solid $teal-200;
  border-radius: 4px;
  &:before {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 0 5px 5px;
    border-color: $teal-200 transparent;
    left: 50%;
    top: -2px;
    transform: translate(-50%, -50%);
  }
  &:after {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 0 4px 4px;
    border-color: $white transparent;
    left: 50%;
    top: -1px;
    transform: translate(-50%, -50%);
  }
}

.custom-tooltip {
  @include custom-tooltip-styles;
  transform: translate(19%, -1%);
  ul li label {
    max-width: 233px;
  }
}

.custom-tooltip-repassword {
  @include custom-tooltip-styles;
  transform: translate(50%, -1%);
}

.icon-success:before {
  color: $success;
  font-size: 14px;
}
.icon-danger:before {
  color: $danger;
  font-size: 14px;
}
</style>
<template>
  <Layout>
    <div class="mc-auth__form">
      <h1 class="mc-auth__logo pt-5">
        <router-link to="/">
          <img :src="getAsset('primaryLogo', 'login')" alt ref="imgPrimaryLogo" />
        </router-link>
      </h1>
      <div class="mc-auth__form-wrapper mc-auth__form-wrapper--forgot">
        <h4 class="mc-auth__label">{{ $t('forgotPassword.input.reset') }}</h4>
        <p>{{ $t('forgotPassword.text.newPassword') }}</p>
        <b-form @submit.prevent="handleSubmit">
          <b-form-group class="mb-3 form-password text-start" id="input-group-1">
            <label for="text-password">
              {{ $t('forgotPassword.input.newPassword') }} <span class="text-danger">*</span></label
            >
            <b-form-input
              v-if="showPassword"
              id="text-password"
              v-model="$v.password.$model"
              type="text"
              :placeholder="$t('forgotPassword.input.newPassword')"
              :class="{
                'is-invalid': $v.password.required && $v.password.$error,
              }"
              @focus="onShowTooltip({ key: 'Password' })"
              @blur="onHideTooltip({ key: 'Password' })"
            ></b-form-input>
            <b-form-input
              v-else
              id="text-password"
              v-model="$v.password.$model"
              type="password"
              :placeholder="$t('forgotPassword.input.newPassword')"
              :class="{
                'is-invalid': $v.password.required && $v.password.$error,
              }"
              @focus="onShowTooltip({ key: 'Password' })"
              @blur="onHideTooltip({ key: 'Password' })"
            ></b-form-input>
            <i
              @click="togglePassword"
              class="mc-fa-repassword mt-n1"
              :class="{
                'icon-outline_eye': showPassword,
                'icon-outline_eye-off-2': !showPassword,
              }"
            ></i>
            <div class="custom-tooltip mt-2" v-if="showTooltipPassword">
              <ul
                v-for="val in passwordValidationsCases"
                class="mc-tooltip__bottom list-unstyled my-2"
              >
                <li class="mb-2 align-items-center d-flex">
                  <i
                    :class="`me-2 icon-fill_${$v.password[val] ? 'checkmark' : 'close'}-circle ${
                      $v.password[val] ? 'icon-success' : 'icon-danger'
                    }`"
                  ></i>
                  <label :class="$v.password[val] ? 'text-success' : 'text-danger'">{{
                    $t(`password.${val}`)
                  }}</label>
                </li>
              </ul>
            </div>
          </b-form-group>
          <b-form-group class="mb-2 form-password text-start" id="input-group-2">
            <label for="text-repassword"
              >{{ $t('forgotPassword.input.repeat') }} <span class="text-danger">*</span></label
            >
            <b-form-input
              v-if="showRepassword"
              id="text-repassword"
              v-model="$v.repassword.$model"
              type="text"
              :placeholder="$t('forgotPassword.input.repeat')"
              :class="{
                'is-invalid':
                  $v.repassword.required && ($v.repassword.$error || !isPasswordMatched),
              }"
              @focus="onShowTooltip({ key: 'Repassword' })"
              @blur="onHideTooltip({ key: 'Repassword' })"
            ></b-form-input>
            <b-form-input
              v-else
              id="text-repassword"
              v-model="$v.repassword.$model"
              type="password"
              :placeholder="$t('forgotPassword.input.repeat')"
              :class="{
                'is-invalid':
                  $v.repassword.required && ($v.repassword.$error || !isPasswordMatched),
              }"
              @focus="onShowTooltip({ key: 'Repassword' })"
              @blur="onHideTooltip({ key: 'Repassword' })"
            ></b-form-input>
            <i
              @click="toggleRepassword"
              class="mc-fa-repassword mt-n1"
              :class="{
                'icon-outline_eye': showRepassword,
                'icon-outline_eye-off-2': !showRepassword,
              }"
            ></i>
            <div class="mt-2" v-if="showTooltipRepassword && !isPasswordMatched">
              <label :class="isPasswordMatched ? 'text-success' : 'text-danger'">{{
                $t(`password.matched`)
              }}</label>
            </div>
          </b-form-group>
          <div class="mt-5">
            <b-button
              type="submit"
              variant="primary"
              class="w-100"
              :disabled="$v.password.$invalid || !isPasswordMatched"
              >{{ $t('forgotPassword.action.savePassword') }}
            </b-button>
          </div>
        </b-form>
      </div>
      <div class="mc-auth__copyright">
        <span
          :hidden="
            getAsset('copyrightLogo', 'general') == null ||
            getAsset('copyrightLogo', 'general') == ''
          "
          >{{ $t('login.text.presented') }}
          <img :src="getAsset('copyrightLogo', 'general')" alt class="ms-2" ref="imgCopyrightLogo"
        /></span>
      </div>
    </div>
  </Layout>
</template>
